import React from 'react';

import '../style/phone.css';

const Phone = ({children}) => (
  <div className="iPhone">
    <div className="iPhoneInner">
      <div className="camera" />
      <div className="smallTopCirc" />
      <div className="oval" />
      <div className="iScreen">
        <div style={{padding: 15}}>{children}</div>
      </div>
      <div className="circButton" />
    </div>
  </div>
);

export default Phone;



// WEBPACK FOOTER //
// ./src/components/Phone.js